import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_5 = { class: "col-16 col-md-6" }
const _hoisted_6 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = { class: "col-12 col-md-6 d-flex justify-content-end" }

import { ref, computed, onMounted } from "vue";
import api from "@/utils/axios";

interface UserPagination {
  searchTerm: string;
  total: number;
  per_page: number;
  from: number;
  to: number;
  current_page: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportedToday',
  setup(__props) {

const dir = ref(false);
const ExportToday = ref<any[]>([]);

const columns = [
  { label: "N°", field: "num" },
  { label: "Code denvoi", field: "code" },
  { label: "Nom du magasin", field: "store" },
  { label: "Téléphone", field: "phone" },
  { label: "Ville", field: "city_name" },
  { label: "Destinataire", field: "receiver" },
  { label: "Crbt", field: "price" },
  { label: "Zone", field: "zone_name" },
];

const users1 = ref<UserPagination>({
  searchTerm: "",
  total: 0,
  per_page: 10,
  from: 1,
  to: 0,
  current_page: 1,
});

const getData = async (page = 1) => {
  try {
    users1.value.current_page = page;
    const res = await api.get(`/api/auth/ExportTodayReported`, {
      params: {
        searchTerm: users1.value.searchTerm,
        page: users1.value.current_page,
        per_page: users1.value.per_page,
      },
    });
    ExportToday.value = res.data.users.data;
    users1.value = res.data.users;
  } catch (e) {
    console.error(e);
  }
};

onMounted(getData);

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "me-2" }, "Voir", -1)),
          _createVNode(_component_v_select, {
            modelValue: users1.value.per_page,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((users1.value.per_page) = $event)),
            options: [10, 25],
            clearable: false,
            class: "per-page-selector d-inline-block mx-2",
            onInput: getData
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", null, "sur " + _toDisplayString(users1.value.total) + " entité", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "me-2" }, "Chercher", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((users1.value.searchTerm) = $event)),
                type: "text",
                class: "form-control d-inline-block",
                placeholder: "chercher",
                onChange: getData
              }, null, 544), [
                [_vModelText, users1.value.searchTerm]
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_vue_good_table, {
        columns: columns,
        rows: ExportToday.value,
        rtl: dir.value
      }, {
        "table-row": _withCtx((props) => [
          (props.column.field === 'num')
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(props.row.originalIndex + 1), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["rows", "rtl"]),
      _createElementVNode("div", _hoisted_10, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-12 col-md-6" }, null, -1)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_PaginatorContent, {
            pagination: users1.value,
            offset: 9,
            onPaginate: getData
          }, null, 8, ["pagination"])
        ])
      ])
    ])
  ]))
}
}

})